import { useTranslation } from "next-i18next"
import SignAdvantageItems from "../SignAdvantageItems"

function AdvantagesList({ step }) {
  const { t } = useTranslation("common")

  const list = {
    0: [
      {
        image: "💾",
        title: t("SIGNUP_SAVE_SESSIONS_TITLE"),
        description: t("SIGNUP_SAVE_SESSIONS_DESC"),
      },
      {
        image: "🌱",
        title: t("SIGNUP_CUSTOMIZED_SUPPORT_TITLE"),
        description: t("SIGNUP_CUSTOMIZED_SUPPORT_DESC"),
      },
      {
        image: "🕵️",
        title: t("SIGNUP_PRIVACY_MATTERS_TITLE"),
        description: t("SIGNUP_PRIVACY_MATTERS_DESC"),
      },
    ],
    1: [
      {
        image: "🔐",
        title: t("SIGNUP_END_TO_END_TITLE"),
        title: "End-to-End Encryption",
        description: t("SIGNUP_END_TO_END_DESC"),
      },
      {
        image: "🔄",
        title: t("SIGNUP_REAL_TIME_FEEDBACK_TITLE"),
        description: t("SIGNUP_REAL_TIME_FEEDBACK_DESC"),
      },
      {
        image: "🔈",
        title: t("SIGNUP_NATURAL_VOICE_TITLE"),
        description: t("SIGNUP_NATURAL_VOICE_DESC"),
      },
    ],
  }

  return <SignAdvantageItems items={list[step]} />
}

export default AdvantagesList
